//Node Modules
import axios from 'axios'
//Components
import Pagination from '../../components/utility/Pagination'

export default {
    components: {Pagination},
    props: {
        endpoint: {
            type: String,
            required: true
        },
        filtersQueryString: {
            type: String,
            required: true
        },
        limit: {
            type: Number,
            required: true
        },
        series: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        products: [],
        pagination: {
            cur_page: 1,
            page_count: 0,
            prevent_watch: false
        },
        loading: false,
    }),
    methods: {
        getProducts() {
            this.loading = true
            //get paginated products data
            axios.get(this.endpointWithGetData)
                .then(response => {
                    this.loading = false
                    this.products = response.data.data
                    this.pagination.page_count = response.data.meta.last_page
                    this.pagination.cur_page = response.data.meta.current_page
                    this.$emit('product-list-updated', this.series, response.data.meta.total)
                })
        },
        setCurrentPage(page) {
            this.pagination.cur_page = page

            document.getElementById('products-controls').scrollIntoView({
                behavior: 'smooth'
            });
        }
    },
    computed: {
        endpointWithGetData() {
            return `${this.endpoint}?${this.filtersQueryString}&page=${this.pagination.cur_page}&limit=${this.limit}`
        }
    },
    watch: {
        filtersQueryString: {
            handler() {
                this.pagination.cur_page === 1
                    ? this.getProducts()
                    : this.pagination.cur_page = 1
            }
        },
        'pagination.cur_page': {
            handler() {
                this.getProducts()
            }
        },
        limit: {
            handler() {
                this.getProducts()
            }
        }
    },
    mounted() {
        this.getProducts()
    }
}
